import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const BreadcrumbSchema = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);

  // Build breadcrumbs dynamically based on the URL path
  const breadcrumbs = pathSegments.map((segment, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: segment.replace(/-/g, " ").toUpperCase(),
    item: `${window.location.origin}/${pathSegments.slice(0, index + 1).join("/")}`,
  }));

  // Add a "Home" breadcrumb
  breadcrumbs.unshift({
    "@type": "ListItem",
    position: 1,
    name: "Home",
    item: window.location.origin,
  });

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": breadcrumbs,
        })}
      </script>
    </Helmet>
  );
};

export default BreadcrumbSchema;
